import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../creators/assets/images/link.png'


const _withScopeId = n => (_pushScopeId("data-v-c46e2900"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mb-3 p-d-flex p-ai-baseline" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "p-input-icon-left w-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-link" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("img", {
      src: $setup.parseImages[$props.type],
      class: "product-image"
    }, null, 8, _hoisted_2),
    _createElementVNode("span", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_InputText, {
        class: "default-input w-100",
        type: "text",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeProductUrs', $setup.valueProductNameInput, $props.type, $props.index))),
        modelValue: $setup.valueProductNameInput,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.valueProductNameInput) = $event)),
        placeholder: `Enter your product ${$setup.parsePlaceholder} URL`
      }, null, 8, ["modelValue", "placeholder"])
    ])
  ]))
}